var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_734_2025)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 25C5.60747 25 0 19.3925 0 12.5C0 5.60747 5.60747 0 12.5 0C19.3925 0 25 5.60747 25 12.5C25 19.3925 19.3925 25 12.5 25ZM18.9823 16.8912C19.0564 16.8911 19.1275 16.8616 19.1799 16.8092C19.2323 16.7568 19.2618 16.6857 19.2619 16.6116V8.76411L12.902 13.8145C12.7843 13.908 12.6421 13.9547 12.5 13.9547C12.3578 13.9547 12.2156 13.908 12.0979 13.8145L5.73809 8.76411V16.6116C5.73818 16.6857 5.76766 16.7568 5.82006 16.8092C5.87247 16.8616 5.94352 16.8911 6.01763 16.8912H18.9823ZM18.0077 8.10884L12.5 12.4826L6.99224 8.10884H18.0077ZM20.555 8.38838V16.6117C20.555 17.4789 19.8495 18.1844 18.9823 18.1844H6.01763C5.15044 18.1844 4.44502 17.4789 4.44502 16.6117V8.38838C4.44502 7.52124 5.15049 6.81577 6.01763 6.81577H18.9823C19.8495 6.81572 20.555 7.52124 20.555 8.38838Z",
    fill: "#F26C38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_734_2025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcn);
export default __webpack_public_path__ + "static/media/email_icn.421efb277469af215c5f7ca2b81100c3.svg";
export { ForwardRef as ReactComponent };